<template>
  <div>
    <generic-table
      ref="datatable"
      :title="$t('signers')"
      :columns="columns"
      :column_search="true"
      resource_url="/signer/datatables"
    >
      <template v-slot:buttons>
        <button class="button is-secondary is-rounded" @click="create">
          <span class="icon"><i class="fa fa-plus"></i></span>
          <span>{{ $t("add") }}</span>
        </button>
      </template>
    </generic-table>
  </div>

  <signer-modal ref="signer_modal" @success="refresh" />
</template>

<script>
// import GenericTable from "../../../../app/src/components/generic_table/GenericTable.vue";
import GenericTable from "@/components/generic_table/GenericTable.vue";
import {
  generate_datatables_buttons,
  confirm_deletion_dialog,
  del,
  error_message,
  api_host,
  format_currency,
} from "@/utils";
import SignerModal from "./signer_modal/Index.vue";

export default {
  name: "SignersDatatable",
  components: { GenericTable, SignerModal },
  data() {
    let v = this;
    return {
      api_host,
      columns: [
        {
          title: v.$t("name"),
          name: "name",
          searchable: true,
          data: (row) => {
            // return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
            return row.name || "";
          },
        },
        {
          title: v.$t("signature"),
          searchable: false,
          data: (row) => {
            // return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
            if (
              row.settings &&
              row.settings.images &&
              row.settings.images.length
            ) {
              let list = row.settings.images.reduce((acc, image) => {
                return `${acc}<div class="column is-4"><figure class="image is-128x128">
                                <img src="${api_host}/drive/static/${image.final_name}" alt="${image.original_name}" />
                              </figure></div>`;
              }, "");
              return `<div class="columns is-multiline">${list}</div>`;
            } else {
              return "";
            }
            return JSON.stringify(row);
          },
        },
        {
          title: v.$t("options"),
          width: "20%",
          searchable: false,
          data: (row) => {
            return generate_datatables_buttons([
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("edit"),
                icon: "fa fa-edit",
                icon_class: "is-small",
                click: function (e) {
                  // console.log("edit order", e.detail.uuid);
                  v.$refs.signer_modal.edit_modal(e.detail.uuid);
                },
              },
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("delete"),
                icon: "fa fa-trash",
                icon_class: "is-small has-text-danger",
                click: (e) => {
                  let uuid = e.detail.uuid;
                  confirm_deletion_dialog(
                    v.$t("are you sure to delete signer?"),
                    v,
                    () => {
                      del("/signer", { uuid: uuid })
                        .then(() => {
                          v.refresh();
                        })
                        .catch((error) => {
                          error_message(error);
                        });
                    }
                  );
                },
              },
            ]);
          },
        },
      ],
    };
  },
  methods: {
    create() {
      let v = this;
      v.$refs.signer_modal.show_modal();
    },
    refresh() {
      let v = this;
      v.$refs.datatable.refresh();
    },
  },
  mounted() {
    this.refresh();
  },
};
</script>

<style></style>
